import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders } from "@/lib/api";
import { useLocale } from "@/i18n";

export default function ImportProfile({ onImported }) {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImport = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/barber/import-profile`, { url: url.trim() }, { headers: authHeaders() });
      toast.success(`${res.data.services_imported} ${t("import_success")}`);
      setOpen(false);
      setUrl("");
      onImported?.();
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : t("import_error"));
    } finally {
      setLoading(false);
    }
  };

  if (!open) {
    return (
      <button
        data-testid="import-profile-toggle"
        type="button"
        onClick={() => setOpen(true)}
        className="w-full text-center text-xs text-zinc-600 hover:text-amber-500 underline underline-offset-4 decoration-zinc-800 hover:decoration-amber-500/50 transition-colors py-2"
      >
        {t("import_toggle")}
      </button>
    );
  }

  return (
    <form onSubmit={handleImport} className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-4 space-y-3" data-testid="import-profile-panel">
      <p className="text-xs text-zinc-500 leading-relaxed">{t("import_hint")}</p>
      <input
        data-testid="import-profile-url-input"
        type="url"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder={t("import_url_ph")}
        className="w-full h-11 px-3 rounded-lg bg-zinc-950 border border-zinc-800 text-zinc-100 placeholder:text-zinc-600 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 focus:outline-none transition-colors text-sm"
      />
      <div className="flex gap-2">
        <button
          data-testid="import-profile-submit-btn"
          type="submit"
          disabled={loading || url.trim().length < 10}
          className="flex-1 h-10 rounded-lg bg-amber-500 text-zinc-950 text-sm font-bold hover:bg-amber-400 transition-colors active:scale-95 disabled:opacity-60"
        >
          {loading ? t("import_working") : t("import_btn")}
        </button>
        <button
          data-testid="import-profile-cancel-btn"
          type="button"
          onClick={() => setOpen(false)}
          className="h-10 px-4 rounded-lg border border-zinc-800 text-zinc-400 text-sm font-semibold hover:border-zinc-600 transition-colors"
        >
          {t("cancel")}
        </button>
      </div>
    </form>
  );
}
